import { asyncCallRoutePost } from '../helpers/api';
import { Popup } from './popup';

export class SaveButton {
	constructor( element ) {
		this.element = element;
		this.button = element.querySelector( '.js-qala-ssc-save-cart-button' );

		this.popupElement = document.querySelector( '.js-qala-ssc-popup' );

		this.popup = new Popup( this.popupElement, this.button );

		const { routeUrl, _wpnonce } = window.QalaSaveShareCart.saveCartRouteObj;

		this.routeUrl = routeUrl;
		this._wpnonce = _wpnonce;
	}

	/**
	 * Initialize the component, setup all event listeners and such.
	 *
	 * @return {void}
	 */
	init() {
		this.button.disabled = false;
		this.button.addEventListener( 'click', this.handleSaveButtonClick.bind( this ) );
	}

	/**
	 * Handle the click event on the save button.
	 *
	 * @param {Object} event Click event
	 * @return {void}
	 */
	handleSaveButtonClick( event ) {
		event.preventDefault();

		this.openPopup();
	}

	/**
	 * Open the popup.
	 *
	 * @return {void}
	 */
	openPopup() {
		this.popup.open( this.button );

		this.saveCart();
	}

	/**
	 * Save the cart by sending the request.
	 *
	 * @return {void}
	 */
	async saveCart() {
		try {
			const response = await this.startSave();

			this.validateResponse( response );

			this.endSave( response );
		} catch ( error ) {
			this.handleSaveErrors( error );
		}
	}

	/**
	 * Validates that the response was actually a success.
	 *
	 * @param {Object} response Response object
	 * @return {void}
	 */
	validateResponse( response ) {
		if ( ! response.data?.status ) {
			throw new Error( response?.message || 'Unknown error' );
		}

		if ( response.data.status !== 200 ) {
			throw new Error( response?.message || 'Unknown error' );
		}
	}

	/**
	 * Starts the save process.
	 *
	 * @return {Promise} Promise object.
	 */
	async startSave() {
		this.popup.disableClose();
		this.popup.showLoading();

		return asyncCallRoutePost( this.routeUrl, this._wpnonce );
	}

	/**
	 * Ends the save process.
	 *
	 * @param {Object} response Response object
	 * @return {void}
	 */
	endSave( response ) {
		this.popup.showSuccess( response?.data );
	}

	/**
	 * Ends the save process.
	 *
	 * @param {string} error
	 * @return {void}
	 */
	handleSaveErrors( error ) {
		this.popup.showError( error );
	}
}
